import { render } from "./App.vue?vue&type=template&id=596a94e3"
const script = {}

import exportComponent from "/var/www/pc-coupons/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__